import type { CSSProperties, ReactNode } from "react";

type Tone = "primary" | "negative" | "neutral" | "positive";

const TONES: Record<Tone, { bg: string; fg: string }> = {
  primary: { bg: "var(--primary-normal)", fg: "var(--static-white)" },
  negative: { bg: "var(--status-negative)", fg: "var(--static-white)" },
  neutral: { bg: "var(--fill-strong)", fg: "var(--label-normal)" },
  positive: { bg: "var(--status-positive)", fg: "var(--static-white)" },
};

export interface BadgeProps {
  type?: "dot" | "count" | "text";
  count?: number;
  max?: number;
  tone?: Tone;
  children?: ReactNode;
  style?: CSSProperties;
}

export function Badge({ type = "count", count = 0, max = 99, tone = "negative", children, style }: BadgeProps) {
  const t = TONES[tone] || TONES.negative;
  if (type === "dot") {
    return (
      <span
        style={{ display: "inline-block", width: 8, height: 8, borderRadius: "var(--radius-full)", background: t.bg, ...style }}
      />
    );
  }
  const text = type === "count" ? (count > max ? `${max}+` : String(count)) : children;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minWidth: 18,
        height: 18,
        padding: "0 5px",
        borderRadius: "var(--radius-full)",
        background: t.bg,
        color: t.fg,
        fontFamily: "var(--font-sans)",
        fontSize: "var(--font-size-caption-2)",
        fontWeight: 700,
        lineHeight: 1,
        boxSizing: "border-box",
        ...style,
      }}
    >
      {text}
    </span>
  );
}

export default Badge;
